import { render, staticRenderFns } from "./OrgNTSQuota.vue?vue&type=template&id=11a659b0&scoped=true&"
import script from "./OrgNTSQuota.vue?vue&type=script&lang=js&"
export * from "./OrgNTSQuota.vue?vue&type=script&lang=js&"
import style0 from "./OrgNTSQuota.vue?vue&type=style&index=0&id=11a659b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a659b0",
  null
  
)

export default component.exports